import AdvertisementsAPI from '@/modules/advertisements/api/advertisements'

export default {
  updateAdvertisements({ commit }) {
    return AdvertisementsAPI.getAdvertisements().then((data) => {
      commit('setAllAdvertisements', data.advertisements)
    })
  },
}
